module.exports = [
	{
		"name": "Business Associate Agreement (BAA - Editable)",
		"papers": [
			{
				"title": "Business Associate Agreement (BAA)",
				"id": "auth0-baa-editable",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-word-92c794e490.svg",
				"date": "October, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-BAA.docx"
					}
				]
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/baa-editable/data/baaPapers.json
// module id = 1403
// module chunks = 0